import React from "react";
import { Tabs, Table } from "antd";
import { facultyProfileConfig } from "../../config/facultyProfileConfig";
import {
  getDuplicateTeachingLoadKeys,
  teachingLoadDuplicateKey,
} from "../../utils/generalUtils";
import "../../styles/components/facultyProfile/teachingLoadTabs.scss";

// Only these two tabs are keyed by Course No. — Outside UP is
// summarized per college/term instead, so duplicates don't apply there.
const DUPLICATE_CHECKED_TABS = ["upou", "otherUp"];

export default function TeachingLoadTabs({
  activeTab,
  onTabChange,
  selectedTerms,
  onEdit,
  teachingLoadUpouData,
  teachingLoadOtherUpData,
  teachingLoadOutsideUpData,
}) {
  const tabs = facultyProfileConfig.teachingLoad.tabs;

  const dataMap = {
    upou: teachingLoadUpouData,
    otherUp: teachingLoadOtherUpData,
    outsideUp: teachingLoadOutsideUpData,
  };

  const filteredData = (data) =>
    selectedTerms.length === 0
      ? data
      : data.filter((item) => selectedTerms.includes(item.academic_term));

  const items = Object.entries(tabs).map(([key, tab]) => {
    const tabData = filteredData(dataMap[key]);
    const duplicateKeys = DUPLICATE_CHECKED_TABS.includes(key)
      ? getDuplicateTeachingLoadKeys(dataMap[key])
      : new Set();

    return {
      key,
      label: tab.label,
      children: (
        <Table
          columns={tab.columns}
          dataSource={tabData}
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 4 }}
          rowClassName={(record) =>
            duplicateKeys.has(teachingLoadDuplicateKey(record))
              ? "teaching-load-duplicate-row"
              : ""
          }
          onRow={(record) => ({
            onClick: () => {
              if (onEdit) onEdit(record);
            },
            style: { cursor: "pointer" },
          })}
          rowKey={(record) => record.id}
        />
      ),
    };
  });

  return (
    <Tabs
      className="teaching-load-tabs"
      activeKey={activeTab}
      items={items}
      onChange={onTabChange}
    />
  );
}
